module.exports = __webpack_public_path__ + "img/about-8.c121d77c.jpg";